import { Box, Checkbox, HStack, Text, Tooltip } from '@chakra-ui/react';
import { getIslandAddonState, ISLAND_ADDONS, setIslandAddonState } from '@rta/rta-blueprint-component';
import { Island, Kitchen, useSubscription } from '@rta/rta-blueprint-library';

export type IslandAddonControlsProps = {
	island: Island;
	kitchen: Kitchen;
	readonly: boolean;
};

export const IslandAddonControls = (props: IslandAddonControlsProps) => {
	const { island, kitchen, readonly } = props;

	// Re-render when a toggle writes through kitchen.blueprintOverrides or resizes the island.
	useSubscription(kitchen, false, [['kitchen', 'updated'], ['island', 'updated']]);

	return (
		<Box width="100%">
			{ISLAND_ADDONS.map((addon) => (
				<Tooltip key={addon.key} label={addon.derived ? `Decided by the model — ${addon.hint}` : addon.hint} placement="left" openDelay={400}>
					<HStack justifyContent="space-between" alignItems="center" py="2px">
						<Checkbox
							size="sm"
							isChecked={getIslandAddonState(kitchen, island, addon.key)}
							isDisabled={readonly || addon.derived || addon.comingSoon === true || (addon.key === 'adaSizing' && island.sizeLocked)}
							onChange={(event) => setIslandAddonState(kitchen, island, addon.key, event.target.checked)}
						>
							<Text fontSize="small">{addon.label}</Text>
						</Checkbox>
						{addon.derived ? <Text fontSize="10px" color="gray.500">auto</Text> : null}
						{addon.comingSoon ? <Text fontSize="10px" color="orange.400">coming soon</Text> : null}
						{addon.key === 'adaSizing' && island.sizeLocked ? <Text fontSize="10px" color="gray.500">size locked</Text> : null}
					</HStack>
				</Tooltip>
			))}
		</Box>
	);
};
